module.exports = __webpack_public_path__ + "img/profilmesser.00d5db0f.png";